module.exports = __webpack_public_path__ + "static/media/resume.be575bbf.pdf";